import React from 'react';

const GiftBasket = ({ selectedGifts, onRemoveGift, onClearAll, cartTotalUSD, cartTotalBHD, remainingBalance, MAX_BUDGET }) => {
  if (selectedGifts.length === 0) return null;

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-100 mb-6 overflow-hidden">
      {/* Basket Header */}
      <div className="bg-[#19BFB7] text-white p-4">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold">🎁 Gift Basket</h2>
            <div className="text-sm opacity-90">
              {selectedGifts.length} item{selectedGifts.length !== 1 ? 's' : ''} selected
            </div>
          </div>
          <button
            onClick={onClearAll}
            className="bg-white/20 hover:bg-white/30 text-white px-4 py-2 rounded-lg font-medium transition-colors"
          >
            Clear All
          </button>
        </div>
      </div>

      {/* Basket Items */}
      <div className="p-4 space-y-3 max-h-96 overflow-y-auto">
        {selectedGifts.map((gift) => (
          <div
            key={gift.id}
            className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {/* Gift Image */}
            <div className="w-16 h-16 bg-gray-200 rounded-lg flex-shrink-0 overflow-hidden">
              {gift.imageUrl ? (
                <img
                  src={gift.imageUrl}
                  alt={gift.name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<span class="text-gray-400 text-2xl flex items-center justify-center h-full">🎁</span>';
                  }}
                />
              ) : (
                <span className="text-gray-400 text-2xl flex items-center justify-center h-full">🎁</span>
              )}
            </div>

            {/* Gift Details */}
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-gray-800 truncate" title={gift.name}>
                {gift.name}
              </h4>
              <div className="text-sm text-gray-600 mt-1">
                {gift.prices?.BHD.toFixed(3)} BHD / ${gift.prices?.USD.toFixed(2)}
              </div>
            </div>

            {/* Remove Button */}
            <button
              onClick={() => onRemoveGift(gift)}
              className="flex-shrink-0 p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
              title="Remove gift"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
        ))}
      </div>

      {/* Basket Footer - Totals */}
      <div className="border-t border-gray-200 p-4 bg-gray-50">
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Total Value:</span>
            <span className="font-semibold text-gray-800">
              {cartTotalBHD.toFixed(3)} BHD / ${cartTotalUSD.toFixed(2)}
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Remaining Balance:</span>
            <span className={`font-semibold ${remainingBalance < 50 ? 'text-red-600' : 'text-green-600'}`}>
              {remainingBalance.toFixed(3)} BHD of {MAX_BUDGET} BHD
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftBasket;
